import React from 'react';
import { Link } from 'react-router-dom';
import { Building2, ArrowLeft, Mail, Phone, MapPin, FileCheck } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

const Row = ({ label, children }) => (
  <div className="grid grid-cols-1 md:grid-cols-[180px_1fr] gap-2 py-3 border-b border-[#C4A55A]/10 last:border-b-0">
    <div className="text-gray-400 text-sm font-medium">{label}</div>
    <div className="text-white">{children}</div>
  </div>
);

export const Impressum = () => {
  return (
    <div className="bg-black min-h-screen text-white">
      <Header />
      <main className="container mx-auto px-4 pt-32 pb-16 max-w-4xl" data-testid="page-impressum">
        <Link
          to="/"
          className="inline-flex items-center text-[#C4A55A] hover:text-[#D4B56A] mb-6 text-sm"
          data-testid="impressum-back-link"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Zurück zur Startseite
        </Link>

        <div className="flex items-center gap-3 mb-2">
          <Building2 className="h-10 w-10 text-[#C4A55A]" />
          <h1 className="text-4xl md:text-5xl font-bold">Impressum</h1>
        </div>
        <p className="text-gray-400 mb-10">
          Angaben gemäss Schweizer Recht (Bundesgesetz gegen den unlauteren Wettbewerb / UWG)
        </p>

        <section className="bg-[#1a1a1a] border border-[#C4A55A]/20 rounded-2xl p-6 md:p-8 mb-8">
          <h2 className="text-2xl font-semibold mb-4 flex items-center gap-2">
            <Building2 className="h-6 w-6 text-[#C4A55A]" />
            Anbieter
          </h2>
          <Row label="Firma">Löwenherz Invest AG</Row>
          <Row label="Adresse">
            <span className="inline-flex items-start gap-2">
              <MapPin className="h-4 w-4 text-[#C4A55A] mt-1 shrink-0" />
              <span>
                Wildenstrasse 3<br />
                8212 Neuhausen am Rheinfall<br />
                Schweiz
              </span>
            </span>
          </Row>
          <Row label="E-Mail">
            <a href="mailto:office@loewenherz.ag" className="inline-flex items-center gap-2 text-[#C4A55A] hover:text-[#D4B56A]">
              <Mail className="h-4 w-4" />
              office@loewenherz.ag
            </a>
          </Row>
          <Row label="Telefon">
            <a href="tel:+41525510140" className="inline-flex items-center gap-2 text-[#C4A55A] hover:text-[#D4B56A]">
              <Phone className="h-4 w-4" />
              +41 52 55 101 40
            </a>
          </Row>
        </section>

        <section className="bg-[#1a1a1a] border border-[#C4A55A]/20 rounded-2xl p-6 md:p-8 mb-8">
          <h2 className="text-2xl font-semibold mb-4 flex items-center gap-2">
            <FileCheck className="h-6 w-6 text-[#C4A55A]" />
            Handelsregister
          </h2>
          <Row label="Handelsregister-Nr.">CHE-431.558.665</Row>
          <Row label="Eintragsort">Handelsregisteramt Schaffhausen</Row>
          <Row label="UID-Nummer">CHE-431.558.665</Row>
        </section>

        <section className="bg-[#1a1a1a] border border-[#C4A55A]/20 rounded-2xl p-6 md:p-8 mb-8">
          <h2 className="text-2xl font-semibold mb-4">Vertretungsberechtigte Person</h2>
          <Row label="Verwaltungsrat">Matthias Kirchner</Row>
        </section>

        <section className="bg-[#1a1a1a] border border-[#C4A55A]/20 rounded-2xl p-6 md:p-8 mb-8">
          <h2 className="text-2xl font-semibold mb-4">Haftungsausschluss</h2>
          <div className="text-gray-300 space-y-3 leading-relaxed">
            <p>
              Der Autor übernimmt keinerlei Gewähr hinsichtlich der inhaltlichen Richtigkeit,
              Genauigkeit, Aktualität, Zuverlässigkeit und Vollständigkeit der Informationen.
              Haftungsansprüche gegen den Autor wegen Schäden materieller oder immaterieller Art,
              welche aus dem Zugriff oder der Nutzung bzw. Nichtnutzung der veröffentlichten
              Informationen, durch Missbrauch der Verbindung oder durch technische Störungen
              entstanden sind, werden ausgeschlossen.
            </p>
            <p>
              Alle Angebote sind unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile
              der Seiten oder das gesamte Angebot ohne besondere Ankündigung zu verändern, zu
              ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.
            </p>
          </div>
        </section>

        <section className="bg-[#1a1a1a] border border-[#C4A55A]/20 rounded-2xl p-6 md:p-8 mb-8">
          <h2 className="text-2xl font-semibold mb-4">Haftung für Links</h2>
          <p className="text-gray-300 leading-relaxed">
            Verweise und Links auf Webseiten Dritter liegen ausserhalb unseres Verantwortungsbereichs.
            Es wird jegliche Verantwortung für solche Webseiten abgelehnt. Der Zugriff und die
            Nutzung solcher Webseiten erfolgen auf eigene Gefahr des jeweiligen Nutzers.
          </p>
        </section>

        <section className="bg-[#1a1a1a] border border-[#C4A55A]/20 rounded-2xl p-6 md:p-8">
          <h2 className="text-2xl font-semibold mb-4">Urheberrechte</h2>
          <p className="text-gray-300 leading-relaxed">
            Die Urheber- und alle anderen Rechte an Inhalten, Bildern, Fotos oder anderen Dateien
            auf dieser Website gehören ausschliesslich der Löwenherz Invest AG oder den speziell
            genannten Rechtsinhabern. Für die Reproduktion jeglicher Elemente ist die schriftliche
            Zustimmung der Urheberrechtsträger im Voraus einzuholen.
          </p>
        </section>

        <p className="text-gray-500 text-sm mt-10 text-center">
          Letzte Aktualisierung: {new Date().toLocaleDateString('de-CH', { day: '2-digit', month: 'long', year: 'numeric' })}
        </p>
      </main>
      <Footer />
    </div>
  );
};
